/** مقادیر نمایشی؛ بدون پیوند واقعی با دیتابیس */
export const KPI_MOCK = {
  total_assets: 4_892_650_000,
  total_liabilities: 2_104_030_000,
  total_revenue: 980_410_000,
  total_expenses: 743_920_000,
};

export const CONTRACTOR_OVERVIEW_MOCK = {
  total_contract_amount: 16_850_000_000,
  certified_statements_amount: 6_920_000_000,
  collected_cash_amount: 4_310_000_000,
  total_project_costs: 3_780_000_000,
  retention_receivable: 642_000_000,
};

export interface RecentDocument {
  id: string;
  number: string;
  dateFa: string;
  description: string;
  debit: number;
  credit: number;
  status: 'قطعی' | 'موقت';
}

export const RECENT_DOCUMENTS: RecentDocument[] = [
  {
    id: 'd1',
    number: 'JE-۱۴۰۳۱۲۲۰۱',
    dateFa: '۱۴۰۳/۱۲/۲۰',
    description: 'ثبت قطعی حقوق و دستمزد اداری ماه قبل',
    debit: 125_900_000,
    credit: 125_900_000,
    status: 'قطعی',
  },
  {
    id: 'd2',
    number: 'JE-۱۴۰۳۱۲۲۰۲',
    dateFa: '۱۴۰۳/۱۲/۲۵',
    description: 'واریز پیش‌دریافت از طرف کارفرما پیمان واحد شمال',
    debit: 450_000_000,
    credit: 450_000_000,
    status: 'قطعی',
  },
  {
    id: 'd3',
    number: 'JE-۱۴۰۴۰۱۰۰۷',
    dateFa: '۱۴۰۴/۰۱/۰۷',
    description: 'خرید مصالح نقد؛ انتقال از بانک ملی به صورت هزینهٔ انباردار',
    debit: 86_740_500,
    credit: 86_740_500,
    status: 'موقت',
  },
];

export interface ProjectPerformanceRow {
  id: string;
  projectCode: string;
  projectName: string;
  contractAmount: number;
  statementCertified: number;
  costsToDate: number;
  margin: number;
  progressPercent: number;
}

export const PROJECT_PERFORMANCE_MOCK: ProjectPerformanceRow[] = [
  {
    id: 'p1',
    projectCode: 'PRJ-401',
    projectName: 'خط انتقال آب شرق',
    contractAmount: 7_200_000_000,
    statementCertified: 2_980_000_000,
    costsToDate: 1_840_000_000,
    margin: 1_140_000_000,
    progressPercent: 43,
  },
  {
    id: 'p2',
    projectCode: 'PRJ-402',
    projectName: 'ساختمان اداری داروگ',
    contractAmount: 5_100_000_000,
    statementCertified: 2_450_000_000,
    costsToDate: 1_510_000_000,
    margin: 940_000_000,
    progressPercent: 51,
  },
  {
    id: 'p3',
    projectCode: 'PRJ-403',
    projectName: 'محوطه‌سازی فاز توسعه',
    contractAmount: 4_550_000_000,
    statementCertified: 1_490_000_000,
    costsToDate: 430_000_000,
    margin: 1_060_000_000,
    progressPercent: 29,
  },
];

export interface StatementQueueRow {
  id: string;
  project: string;
  statementNo: string;
  period: string;
  grossAmount: number;
  deductions: number;
  netPayable: number;
  status: 'ارسال به کارفرما' | 'تایید کارفرما' | 'وصول‌شده';
}

export const STATEMENT_QUEUE_MOCK: StatementQueueRow[] = [
  {
    id: 'st1',
    project: 'خط انتقال آب شرق',
    statementNo: 'SV-401-07',
    period: 'فروردین ۱۴۰۵',
    grossAmount: 780_000_000,
    deductions: 119_000_000,
    netPayable: 661_000_000,
    status: 'ارسال به کارفرما',
  },
  {
    id: 'st2',
    project: 'ساختمان اداری داروگ',
    statementNo: 'SV-402-09',
    period: 'اسفند ۱۴۰۴',
    grossAmount: 640_000_000,
    deductions: 98_000_000,
    netPayable: 542_000_000,
    status: 'تایید کارفرما',
  },
  {
    id: 'st3',
    project: 'محوطه‌سازی فاز توسعه',
    statementNo: 'SV-403-03',
    period: 'فروردین ۱۴۰۵',
    grossAmount: 320_000_000,
    deductions: 46_500_000,
    netPayable: 273_500_000,
    status: 'وصول‌شده',
  },
];

export const COST_BUCKETS_MOCK = [
  { key: 'material', label: 'خرید و مصالح', value: 1_420_000_000, color: 'bg-amber-500' },
  { key: 'subcontract', label: 'پیمانکاران جزء', value: 1_130_000_000, color: 'bg-cyan-500' },
  { key: 'payroll', label: 'حقوق نیروی انسانی', value: 860_000_000, color: 'bg-violet-500' },
  { key: 'overhead', label: 'سربار پروژه', value: 370_000_000, color: 'bg-emerald-500' },
] as const;

export function netProfit(mock = KPI_MOCK): number {
  return mock.total_revenue - mock.total_expenses;
}

export const QUICK_ACCOUNTS_MOCK: { code: string; name: string; balance: number }[] = [
  { code: '110101', name: 'موجودی نقد', balance: -120_505_040 },
  { code: '110201', name: 'حساب‌های دریافتنی', balance: -45_200_410 },
  { code: '210101', name: 'حساب‌های پرداختنی', balance: 98_740_990 },
  { code: '510101', name: 'هزینه عملیاتی', balance: 212_903_660 },
];
